const PingSmall = () => (
  <span className="inline-flex h-4 w-4 relative justify-center items-center">
    <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-stears_red opacity-75"></span>
    <span className="inline-flex rounded-full h-3 w-3 bg-stears_red" />
  </span>
)

export default PingSmall
